import { render, staticRenderFns } from "./breed_page_mng.vue?vue&type=template&id=e63c3b28"
import script from "./breed_page_mng.vue?vue&type=script&lang=js"
export * from "./breed_page_mng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e63c3b28')) {
      api.createRecord('e63c3b28', component.options)
    } else {
      api.reload('e63c3b28', component.options)
    }
    module.hot.accept("./breed_page_mng.vue?vue&type=template&id=e63c3b28", function () {
      api.rerender('e63c3b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/breed_page_mng.vue"
export default component.exports